export default [
  {
    path: '/mic',
    meta: { title: '加入连麦' },
    component: () => import('../../pages/mic/index.vue')
  }
]
